var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main", style: _vm.mainStyle },
    [
      _c(
        "a-form",
        {
          ref: "formLogin",
          staticClass: "user-layout-login",
          attrs: { form: _vm.form, id: "formLogin" },
        },
        [
          _c(
            "a-form-item",
            [
              _c(
                "a-input",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: [
                        "loginName",
                        {
                          initialValue: "",
                          rules: _vm.validatorRules.loginName.rules,
                        },
                      ],
                      expression:
                        "['loginName',{initialValue:'', rules: validatorRules.loginName.rules}]",
                    },
                  ],
                  attrs: {
                    size: "large",
                    type: "text",
                    placeholder: "请输入用户名",
                  },
                },
                [
                  _c("a-icon", {
                    style: { color: "rgba(0,0,0,.25)" },
                    attrs: { slot: "prefix", type: "user" },
                    slot: "prefix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            [
              _c(
                "a-input-password",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: [
                        "password",
                        {
                          initialValue: "",
                          rules: _vm.validatorRules.password.rules,
                        },
                      ],
                      expression:
                        "['password',{initialValue:'', rules: validatorRules.password.rules}]",
                    },
                  ],
                  attrs: {
                    size: "large",
                    type: "password",
                    autocomplete: "false",
                    placeholder: "请输入密码",
                  },
                },
                [
                  _c("a-icon", {
                    style: { color: "rgba(0,0,0,.25)" },
                    attrs: { slot: "prefix", type: "lock" },
                    slot: "prefix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkcodeFlag === "1"
            ? _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-input",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "inputCode",
                                    {
                                      initialValue: "",
                                      rules: _vm.validatorRules.inputCode.rules,
                                    },
                                  ],
                                  expression:
                                    "['inputCode',{initialValue:'', rules: validatorRules.inputCode.rules}]",
                                },
                              ],
                              attrs: {
                                size: "large",
                                type: "text",
                                "default-value": "",
                                placeholder: "请输入验证码",
                              },
                            },
                            [
                              _c("a-icon", {
                                style: { color: "rgba(0,0,0,.25)" },
                                attrs: { slot: "prefix", type: "smile" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 10 },
                    },
                    [
                      _vm.requestCodeSuccess
                        ? _c("img", {
                            staticStyle: { "margin-top": "2px" },
                            attrs: { src: _vm.randCodeImage },
                            on: { click: _vm.handleChangeCheckCode },
                          })
                        : _c("img", {
                            staticStyle: { "margin-top": "2px" },
                            attrs: {
                              src: require("../../assets/checkcode.png"),
                            },
                            on: { click: _vm.handleChangeCheckCode },
                          }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a-form-item",
            [
              _c(
                "a-checkbox",
                {
                  attrs: { checked: _vm.checked },
                  on: { change: _vm.handleChange },
                },
                [_vm._v("记住密码")]
              ),
              _vm.registerFlag === "1"
                ? _c(
                    "router-link",
                    {
                      staticClass: "forge-password",
                      staticStyle: { float: "right", "margin-right": "10px" },
                      attrs: { to: { name: "register" } },
                    },
                    [_vm._v("\n        注册租户\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-form-item",
            { style: _vm.btnStyle },
            [
              _c(
                "a-button",
                {
                  staticClass: "login-button",
                  attrs: {
                    size: "large",
                    type: "primary",
                    htmlType: "submit",
                    loading: _vm.loginBtn,
                    disabled: _vm.loginBtn,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("登 录\n      ")]
              ),
            ],
            1
          ),
          _vm.device === "mobile"
            ? _c(
                "div",
                { staticClass: "login-copyright" },
                [
                  _c(
                    "a-row",
                    [
                      _c("a-col", [
                        _vm._v(
                          "\n          © 2015-2030 Powered By\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#00458a" },
                            attrs: { href: _vm.systemUrl, target: "_blank" },
                          },
                          [_vm._v("官方网站")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }